import { useMutation, useQuery } from '@tanstack/react-query'
import { fetchNeedsYouDismissals, recordNeedsYouDismissal } from './api'

export function useRecordNeedsYouDismissal() {
  return useMutation({ mutationFn: recordNeedsYouDismissal })
}

/**
 * Server-side Needs-you dismissals for the signed-in account (#553). Kept fresh
 * on window focus so switching back to the laptop after dismissing on the phone
 * settles without a reload.
 */
export function useNeedsYouDismissals(accountId: string) {
  return useQuery({
    queryKey: ['needs-you', 'dismissals', accountId],
    queryFn: fetchNeedsYouDismissals,
    enabled: Boolean(accountId),
    staleTime: 30_000,
  })
}
